import React, { useEffect } from 'react';

import { useAuth } from '@context/AuthContext';
import useCurrentUser from '@hooks/useCurrentUser';
import { tryParse } from '@utils/formatter';

const CRISP_WEBSITE_ID = process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID;

interface CrispWrapperProps {
  children: React.ReactNode;
}

const CrispWrapper = ({ children }: CrispWrapperProps) => {
  const { isLoggedIn } = useAuth();
  const { name, phoneNumber, customerEmails, customerSaleOrg, customerName } = useCurrentUser();

  // Setup Crisp live-chat
  // Read documents here: https://help.crisp.chat/en/article/how-to-install-crisp-live-chat-on-nextjs-xh9yse/
  useEffect(() => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID || '';
    window.CRISP_COOKIE_EXPIRE = 72000;
    (() => {
      const d = document;
      const s = d.createElement('script');
      s.src = 'https://client.crisp.chat/l.js';
      s.async = true;
      d.getElementsByTagName('body')[0].appendChild(s);
    })();
  }, []);

  useEffect(() => {
    window.$crisp.push(['do', 'session:reset']);

    if (isLoggedIn) {
      const authObject = tryParse(localStorage.getItem('auth') || '');
      const token = authObject?.token || '';

      window.CRISP_TOKEN_ID = token;
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (customerEmails?.length !== 0) window.$crisp.push(['set', 'user:email', [customerEmails[0]]]);
    if (phoneNumber) window.$crisp.push(['set', 'user:phone', [phoneNumber]]);
    if (name) window.$crisp.push(['set', 'user:nickname', [name]]);
    if (customerSaleOrg) {
      window.$crisp.push([
        'set',
        'session:segments',
        [[customerSaleOrg.id, customerSaleOrg.name, customerSaleOrg.sapCode, customerName]],
      ]);
    }
  }, [customerEmails, phoneNumber, name, customerSaleOrg]);

  return <div>{children}</div>;
};

export default CrispWrapper;
